// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal-mask {
  z-index: 2000;
}
.ant-modal-wrap {
  z-index: 2010;
}
.gyramais-modal {
  width: 49.5rem !important;
}
.gyramais-modal .ant-modal-content {
  border-radius: 1.25rem;
}
.gyramais-modal .ant-modal-content .ant-modal-header {
  background-color: var(--primary-color);
  border-radius: calc(1.25rem - 0.1rem) calc(1.25rem - 0.1rem) 0 0;
  padding: 1.5rem 2.5rem;
  padding-right: 3.75rem;
}
@media (max-width: 768px) {
  .gyramais-modal .ant-modal-content .ant-modal-header {
    padding: 1.5rem;
  }
}
.gyramais-modal .ant-modal-content .ant-modal-header .ant-modal-title {
  white-space: pre-line;
  color: var(--primary-text-color);
  font-size: 1.375rem;
  font-weight: 300;
  line-height: 1.65rem;
}
@media (max-width: 768px) {
  .gyramais-modal .ant-modal-content .ant-modal-header .ant-modal-title {
    font-size: 1.25rem;
    line-height: 1.3rem;
  }
}
.gyramais-modal .ant-modal-content .ant-modal-body {
  padding: 1rem 2.5rem;
}
@media (max-width: 768px) {
  .gyramais-modal .ant-modal-content .ant-modal-body {
    padding: 1rem;
  }
}
.gyramais-modal .ant-modal-content .ant-modal-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0rem 2.5rem 1.5rem 2.5rem;
  border-top: none;
}
.gyramais-modal .ant-modal-content .ant-modal-footer button + button {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .gyramais-modal .ant-modal-content .ant-modal-footer {
    flex-direction: column;
    padding: 1rem;
  }
  .gyramais-modal .ant-modal-content .ant-modal-footer .gyramais-btn {
    width: 100%;
  }
  .gyramais-modal .ant-modal-content .ant-modal-footer button + button {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}
.gyramais-modal .ant-modal-content .ant-modal-close {
  top: 0.625rem;
  right: 0.625rem;
}
.gyramais-modal .ant-modal-content .ant-modal-close .ant-modal-close-icon {
  color: var(--primary-text-color);
}
.gyramais-modal .ant-modal-content .ant-modal-close .ant-modal-close-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/sdk/Modal/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACA;EACE,aAAA;AACF;AAEA;EACE,yBAAA;AAAF;AADA;EAGI,sBAAA;AACJ;AAJA;EAMM,sCAAA;EACA,gEAAA;EACA,sBAAA;EACA,sBAAA;AACN;AACM;EAAA;IACE,eAAA;EAEN;AACF;AAfA;EAgBQ,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAER;AAAQ;EAAA;IACE,kBAAA;IACA,mBAAA;EAGR;AACF;AA5BA;EA8BM,oBAAA;AACN;AACM;EAAA;IACE,aAAA;EAEN;AACF;AApCA;EAsCM,aAAA;EACA,mBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,gBAAA;AAAN;AA3CA;EA8CQ,iBAAA;AAAR;AAGM;EAAA;IACE,sBAAA;IAEA,aAAA;EADN;EAFI;IAMI,WAAA;EADR;EALI;IAUI,cAAA;IACA,kBAAA;EAFR;AACF;AA3DA;EAkEM,aAAA;EACA,eAAA;AAJN;AA/DA;EAsEQ,gCAAA;AAJR;AAlEA;EAyEU,aAAA;EACA,cAAA;AAJV","sourcesContent":[".ant-modal-mask {\n  z-index: 2000;\n}\n.ant-modal-wrap {\n  z-index: 2010;\n}\n\n.gyramais-modal {\n  width: 49.5rem !important;\n  .ant-modal-content {\n    border-radius: @border-radius;\n\n    .ant-modal-header {\n      background-color: var(--primary-color);\n      border-radius: calc(@border-radius - 0.1rem) calc(@border-radius - 0.1rem) 0 0;\n      padding: 1.5rem 2.5rem;\n      padding-right: 3.75rem;\n\n      @media (max-width: @md-screen) {\n        padding: 1.5rem;\n      }\n\n      .ant-modal-title {\n        white-space: pre-line;\n        color: var(--primary-text-color);\n        font-size: 1.375rem;\n        font-weight: 300;\n        line-height: 1.65rem;\n\n        @media (max-width: @md-screen) {\n          font-size: 1.25rem;\n          line-height: 1.3rem;\n        }\n      }\n    }\n\n    .ant-modal-body {\n      padding: 1rem 2.5rem;\n\n      @media (max-width: @md-screen) {\n        padding: 1rem;\n      }\n    }\n\n    .ant-modal-footer {\n      display: flex;\n      align-items: center;\n      justify-content: end;\n\n      padding: 0rem 2.5rem 1.5rem 2.5rem;\n      border-top: none;\n\n      button + button {\n        margin-left: 1rem;\n      }\n\n      @media (max-width: @md-screen) {\n        flex-direction: column;\n\n        padding: 1rem;\n\n        .gyramais-btn {\n          width: 100%;\n        }\n\n        button + button {\n          margin-left: 0;\n          margin-top: 0.5rem;\n        }\n      }\n    }\n\n    .ant-modal-close {\n      top: 0.625rem;\n      right: 0.625rem;\n\n      .ant-modal-close-icon {\n        color: var(--primary-text-color);\n\n        svg {\n          width: 1.5rem;\n          height: 1.5rem;\n        }\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
